import { useCallback } from 'react'

export function useSaveQRCode() {
  const saveQRCode = useCallback((imageUrl: string) => {
    // 创建临时 a 标签下载图片
    const link = document.createElement('a')
    link.href = imageUrl
    link.download = 'qr-code.png'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }, [])

  return { saveQRCode }
}
